
import Vue from 'vue'
import TelephonyCallPanel from '@/views/telephony/TelephonyCallPanel.vue'
import TelephonyMatchCard from '@/views/telephony/TelephonyMatchCard.vue'
import type { TelephonyMatch } from '@/utils/telephonyLookup'

export default Vue.extend({
  name: 'TelephonyDisambiguation',
  components: {
    TelephonyCallPanel,
    TelephonyMatchCard,
  },
  props: {
    matches: {
      type: Array as () => TelephonyMatch[],
      required: true,
    },
    phoneDisplay: {
      type: String,
      required: true,
    },
  },
})
